import React from "react"
import {useTranslation} from "react-i18next"

// Window
import {clampWindowStart, EcgWindowInfo, formatClock, stepWindowStart} from "../ModernEcgGrid/window"

// Styles
import useStyles from "./styles"

type ModernEcgPagerProps = {
    startSec: number
    info: EcgWindowInfo
    onChange(startSec: number): void
}

/**
 * @param props
 */
export default function ModernEcgPager(props: ModernEcgPagerProps) {
    const styles = useStyles();
    const [t] = useTranslation("common");
    const {startSec, info, onChange} = props;

    const start = clampWindowStart(startSec, info);
    const end = Math.min(info.totalSec, start + info.pageSec);
    const atStart = start <= 0;
    const atEnd = start >= info.maxStartSec;
    const readout = `${formatClock(start)} – ${formatClock(end)}`;

    return (
        <div className={styles.pager} role="group" aria-label={t("modern.timeline")}>
            <button
                type="button"
                className={styles.btn}
                disabled={atStart}
                onClick={() => onChange(stepWindowStart(start, -1, info))}
                title={t("modern.page_prev")}
                aria-label={t("modern.page_prev")}
            >
                <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M10 3.5L5.5 8l4.5 4.5"/>
                </svg>
            </button>

            <input
                type="range"
                className={styles.scrub}
                min={0}
                max={info.maxStartSec}
                step="any"
                value={start}
                aria-label={t("modern.timeline")}
                aria-valuetext={readout}
                onChange={event => onChange(clampWindowStart(Number(event.target.value), info))}
            />

            <button
                type="button"
                className={styles.btn}
                disabled={atEnd}
                onClick={() => onChange(stepWindowStart(start, 1, info))}
                title={t("modern.page_next")}
                aria-label={t("modern.page_next")}
            >
                <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M6 3.5L10.5 8 6 12.5"/>
                </svg>
            </button>

            <span className={styles.readout} aria-live="polite">
                {readout}
                <span className={styles.total}>{` / ${formatClock(info.totalSec)}`}</span>
            </span>
        </div>
    )
}
